import { FeatureRequestInfo } from './vo/feature-request-info.model';

/**
 * 特集商品提案状況確認（CXデザイン部用）画面の値を管理するクラス
 *
 * @export KYMW7004Model
 * @class KYMW7004Model
 */
export class KYMW7004Model {
	// 特集商品提案状況一覧
	public featureRequestList: FeatureRequestInfo[] = [];

/**
   * 特集商品提案状況更新情報
   *
   * @memberof KYMW4600Model
   */
	get updatefeatureRequestLists() {
		return this.featureRequestList.filter(_f =>
			_f.check === true
		);
	}
}
